import QuestionCardContainer from '../question-card-container/question-card-container';
import { Draggable, DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import React from 'react';
import QuestionEntity, { EditableState } from '../../../../store/question-store/question-entetiy';
import { TUpdateQuestion } from '../../../../store/question-store/question-store';
import { TReviewModeAdditionalAction } from '../questions-review-mode-container/questions-review-mode-container';
import { observer } from 'mobx-react';

interface IProps {
    question: QuestionEntity;
    index: number;
    updateQuestion: TUpdateQuestion;
    isDisabled: boolean;
    handleProps?: DraggableProvidedDragHandleProps;
    reviewModeAdditionalAction?: TReviewModeAdditionalAction;
    isSpecialActionButton?: boolean;
    isReviewMode?: boolean;
    editableQuestionId: string | null;
    setEditableQuestionState: (id: string | null, value: EditableState) => void;
}

const DraggableQuestionWrapper: React.FC<IProps> = observer(({
  question,
  index,
  reviewModeAdditionalAction,
  updateQuestion,
  isDisabled,
  isSpecialActionButton,
  editableQuestionId,
  setEditableQuestionState,
}): JSX.Element => {
  return (
    <>
      <Draggable
        isDragDisabled={question.editableState === EditableState.OPENED}
        key={question.messageId}
        draggableId={question.messageId}
        index={index}
      >
        {(provided) => (
          <div
            ref={provided.innerRef} { ...provided.dragHandleProps} {...provided.draggableProps}
          >
            <QuestionCardContainer
              reviewModeAdditionalAction={reviewModeAdditionalAction}
              updateQuestion={updateQuestion}
              question={question}
              isDisabled={isDisabled}
              isSpecialActionButton={isSpecialActionButton}
              editableQuestionId={editableQuestionId}
              setEditableQuestionState={setEditableQuestionState}
            />
          </div>
        )}
      </Draggable>
    </>
  );
});

export { DraggableQuestionWrapper };
